<template>
  <p>{{ resolvedText }}</p>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { resolveMergeFields } from "@/use/formatter";

interface Props {
  text: string;
  lenderName: string;
}

const props = withDefaults(defineProps<Props>(), {});

const resolvedText = computed(() => {
  return resolveMergeFields(props.text, {
    lenderName: props.lenderName,
  });
});
</script>
